<div class=" o-modal--medium" id="agrement" style="width: 100%;" >
    <div class="o-modal__head">
       
            <a class="c-profile__languaje">
                <i class="icon icon-world">  </i>
                <span class="js-txt_menu23" style="color:white">
                    <select #langselect  (change)="updateLang(langselect.value)" style="background: transparent;" [(ngModel)]="selectLang" >
                        <option *ngFor="let lang of translate.getLangs()" [value]="lang" style="color:black" > {{lang | uppercase}}</option>
                    </select>
                </span> 
            </a>
       
        <a class="o-modal__close close-modal" (click)="Close()"  matDialogClose></a>
          <label class="o-title o-title--white o-title--medium"> {{'ModalTermsPortal.title' | translate}}</label> 
    </div>
    <mat-dialog-content style="width:95%; margin: 10px;">
            <div class="o-modal__text">
                <span class="o-text" style="white-space: pre-line;">{{'ModalTermsPortal.login-general' | translate}}</span>
                
            </div>
    </mat-dialog-content>
    <div class="o-modal__footer">
         <div>
             <button mat-button mat-dialog-close (click)="Close()" class="btn btn--default " style="color:black" ><u> {{'ModalTermsPortal.btnCancel' | translate}}</u></button>
            <button mat-button (click)="Accept()" class="btn btn--primary" > {{'ModalTermsPortal.btnAccept' | translate}} </button>
        </div> 
    </div>
</div>
